module.exports = __webpack_public_path__ + "img/matthias-dungel.769a7b5b.jpg";